import { lazy } from "react";

import { TeamsAuthWall } from "../teamsAuthWall";

const ProfilePage = lazy(() =>
  import("components/pages/ProfilePage/ProfilePage").then((module) => ({ default: module.ProfilePage })),
);

export const TeamsProfilePage = () => (
  <TeamsAuthWall>
    <ProfilePage hideBackButton />
  </TeamsAuthWall>
);
